import React from "react";
import { cn } from "@/lib/utils";

// 3D "hearing brief assembling from its sections" loader. Pages fly in and
// stack into a brief. Namespaced classes (bam-*), palette-mapped, scaled to
// sit inside a card, and reduced-motion safe (settles to the assembled stack).
const CSS = `
.bam-wrap{--ink:#20242A;--tint:#EDE8DF;--gold:#9C6F2A;display:flex;align-items:center;justify-content:center}
.bam-v{width:100%;max-width:280px;height:196px;perspective:900px;display:flex;align-items:center;justify-content:center;overflow:hidden}
.bam-scale{transform:scale(.62);transform-origin:center;display:flex;align-items:center;justify-content:center}
.bam-s{position:relative;width:150px;height:200px;transform-style:preserve-3d;transform:rotateX(58deg) rotateZ(-32deg)}
.bam-pg{position:absolute;inset:0;border:1px solid var(--ink);background:var(--tint);border-radius:3px;animation:bam-asm 10s cubic-bezier(.3,.7,.3,1) infinite both;animation-delay:calc(var(--i)*.12s)}
.bam-pg::before{content:"";position:absolute;inset:34px 14px 14px;background:repeating-linear-gradient(var(--ink) 0 1px,transparent 1px 12px);opacity:.35}
.bam-pg::after{content:"";position:absolute;left:14px;top:14px;width:50px;height:5px;background:var(--gold);border-radius:2px}
.bam-pg b{position:absolute;right:12px;bottom:10px;font-weight:400;font-size:12px;color:var(--ink);font-family:"Cormorant Garamond",Georgia,serif}
@keyframes bam-asm{
0%{opacity:0;transform:translate3d(calc((var(--i) - 2.5)*140px),-260px,320px) rotateZ(calc(var(--i)*40deg)) rotateX(80deg)}
22%{opacity:1;transform:translate3d(0,0,calc(var(--i)*9px))}
48%{transform:translate3d(0,0,calc(var(--i)*9px))}
62%,82%{transform:translate3d(calc((var(--i) - 2.5)*34px),calc((var(--i) - 2.5)*6px),calc(var(--i)*9px)) rotateZ(calc((var(--i) - 2.5)*9deg))}
94%{opacity:1;transform:translate3d(0,0,calc(var(--i)*9px))}
100%{opacity:0;transform:translate3d(0,0,calc(var(--i)*9px + 60px))}}
@media (prefers-reduced-motion:reduce){.bam-pg{animation:none;opacity:1;transform:translate3d(0,0,calc(var(--i)*9px))}}
`;

export function BriefAssemblyMark({ className, label = "Hearing brief" }) {
  return (
    <div className={cn("bam-wrap", className)} aria-label="Hearing brief assembling from its sections" data-testid="brief-assembly-mark">
      <style>{CSS}</style>
      <div className="bam-v">
        <div className="bam-scale">
          <div className="bam-s">
            <div className="bam-pg" style={{ "--i": 0 }} />
            <div className="bam-pg" style={{ "--i": 1 }} />
            <div className="bam-pg" style={{ "--i": 2 }} />
            <div className="bam-pg" style={{ "--i": 3 }} />
            <div className="bam-pg" style={{ "--i": 4 }} />
            <div className="bam-pg" style={{ "--i": 5 }}><b>{label}</b></div>
          </div>
        </div>
      </div>
    </div>
  );
}
